<div class="container page-top mb-5">
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Software Installation Files</h1>
      <p class="mb-5">You must have a license key to use/activate these products.</p>
    </div>
    <div class="col-12">
      <app-product-filter-chooser
        (filterUpdate)="updateFilter($event)">
      </app-product-filter-chooser>
    </div>
  </div>

  <ng-container *ngIf="entries$ | async as entries; else spinner">
    <div class="row" *ngFor="let entryRow of entries | chunk:3">
      <app-download-without-purchase-entry
        *ngFor="let entry of entryRow; let i = index"
        class="col-md-4 col-12"
        [ngClass]="{'px-md-4': i === 1}"
        [product]="entry.product"
        [version]="entry.version"
        [platforms]="entry.platforms">
      </app-download-without-purchase-entry>
    </div>

    <div *ngIf="entries.length === 0"
         role="status"
         aria-live="polite"
         class="row">
      <div class="col">
          <ng-container
            *ngIf="hasFilterChosen(filter$ | async); else noProducts">
            <h3 class="entries--no-match py-5 h6">
              Nothing matches the search criteria.
            </h3>
          </ng-container>

          <ng-template #noProducts>
            <h3 class="entries--no-products py-5 h6">
              There are no files available to you.
            </h3>
          </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-template #spinner>
    <div id="spinner" role="progressbar">
      <div class="row"
           *ngFor="let entryRow of [1,2,3,4,5] | chunk:3">
        <app-download-without-purchase-entry
          *ngFor="let entry of entryRow; let i = index"
          class="col-md-4 col-12"
          [ngClass]="{'px-md-4': i === 1}" >
        </app-download-without-purchase-entry>
      </div>
    </div>
  </ng-template>
</div>
